import { Link } from "react-router-dom";

function LegitScriptSeal() {
  return (
    <a
      href="https://www.legitscript.com/websites/?checker_keywords=premierpharma.com"
      target="_blank"
      rel="noopener noreferrer"
      title="Verify LegitScript Approval"
      className="flex flex-col items-center gap-1 opacity-80 hover:opacity-100 transition-opacity"
    >
      <img
        src="/legitscript-seal.png"
        alt="LegitScript Approved"
        width="140"
        height="100"
        loading="lazy"
        style={{ width: 140, height: 100, objectFit: "contain" }}
      />
      <span className="text-[10px] text-gray-400 font-medium tracking-wide">LEGITSCRIPT APPROVED</span>
    </a>
  );
}

export default function Footer() {
  return (
    <footer className="bg-primary text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-5 gap-8">
          <div className="md:col-span-2">
            <img src="/logo.svg" alt="Premier Pharma" className="h-8 brightness-0 invert mb-4" />
            <p className="text-gray-400 text-sm max-w-xs">
              Wholesale generic pharmaceuticals for licensed pharmacies and clinics. Transparent pricing, DSCSA-compliant, NABP accredited.
            </p>
          </div>
          <div>
            <h2 className="font-semibold mb-4 text-sm">Company</h2>
            <nav aria-label="Company" className="flex flex-col gap-2">
              <Link to="/about" className="text-gray-400 hover:text-white text-sm transition-colors">About Us</Link>
              <Link to="/products" className="text-gray-400 hover:text-white text-sm transition-colors">Product Catalog</Link>
              <Link to="/auctions" className="text-gray-400 hover:text-white text-sm transition-colors">Daily Deals</Link>
              <Link to="/software" className="text-gray-400 hover:text-white text-sm transition-colors">ScriptTrack Software</Link>
            </nav>
          </div>
          <div>
            <h2 className="font-semibold mb-4 text-sm">Resources</h2>
            <nav aria-label="Resources" className="flex flex-col gap-2">
              <Link to="/faq" className="text-gray-400 hover:text-white text-sm transition-colors">FAQs</Link>
              <Link to="/drugs" className="text-gray-400 hover:text-white text-sm transition-colors">Drug Directory</Link>
              <Link to="/ndc" className="text-gray-400 hover:text-white text-sm transition-colors">NDC Lookup</Link>
              <Link to="/resources/dscsa-compliance" className="text-gray-400 hover:text-white text-sm transition-colors">DSCSA Compliance</Link>
              <Link to="/contact" className="text-gray-400 hover:text-white text-sm transition-colors">Contact Us</Link>
              <Link to="/register" className="text-gray-400 hover:text-white text-sm transition-colors">Open an Account</Link>
              <Link to="/login" className="text-gray-400 hover:text-white text-sm transition-colors">Customer Login</Link>
            </nav>
          </div>
          <div>
            <h2 className="font-semibold mb-4 text-sm">Contact</h2>
            <address className="not-italic flex flex-col gap-2 text-gray-400 text-sm">
              <p>7259 W Franklin Rd</p>
              <p>Boise, Idaho 83709, US</p>
              <div className="flex gap-3 mt-3">
                <a href="https://www.facebook.com/people/Premier-Pharma/100092650552829/" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors">Facebook</a>
                <a href="https://www.instagram.com/premierpharma_/" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors">Instagram</a>
                <a href="https://www.linkedin.com/company/premier-pharmaceuticals" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors">LinkedIn</a>
              </div>
            </address>
          </div>
        </div>
        <div className="border-t border-gray-700 mt-8 pt-8">
          <div className="flex flex-wrap items-center justify-center gap-6 mb-4">
            <a href="https://mybadges.us.openbadges.me/api/badgeitem/c44016ac-de61-418c-951f-86c0cddd258b/metadata" target="_blank" rel="noopener noreferrer" title="NABP Drug Distributor" className="flex flex-col items-center gap-1 opacity-80 hover:opacity-100 transition-opacity">
              <img src="/nabp-badge.png" alt="NABP Accredited Drug Distributor" width="48" height="48" loading="lazy" className="w-12 h-12 object-contain brightness-0 invert" />
              <span className="text-[10px] text-gray-400 font-medium tracking-wide">NABP ACCREDITED</span>
            </a>
            <LegitScriptSeal />
          </div>
          <div className="text-center text-gray-400 text-sm">
            &copy; {new Date().getFullYear()} PREMIER PHARMA, ALL RIGHTS RESERVED.
          </div>
        </div>
      </div>
    </footer>
  );
}
